import attrs from "attrs";

import Plugin from "@/scripts/core/Plugin";
import init from "@/scripts/core/init";
import generateId from "@/scripts/helpers/generateId";
import toArray from "@/scripts/helpers/dom/toArray";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";
import { CLASSES } from "@/scripts/helpers/constants";

class Offcanvas extends Plugin {
  defaults() {
    return {
      triggerSelector: "[data-offcanvas-trigger]",
      menuSelector: "[data-offcanvas-menu]",
      containerSelector: "[data-offcanvas-container]",
      overlaySelector: "[data-offcanvas-overlay]",
      searchPanel: ".header-search-panel",
      searchButton: ".header-navbar__item--search",
      loginButton: ".header-navbar__item--login"
    };
  }

  init() {
    this.setA11yAttributes();
  }

  buildCache() {
    this.triggers = toArray(
      document.querySelectorAll(this.options.triggerSelector)
    );
    // TODO: can`t set `containerSelector` to <html> at the moment
    this.container = document.querySelector("html");
    this.overlay = document.querySelector(this.options.overlaySelector);
    this.menu = document.querySelector(this.options.menuSelector);
    this.searchButton = document.querySelector(this.options.searchButton);
    this.loginButton = document.querySelector(this.options.loginButton);
    this.body = document.querySelector("body");
    this.mobileMenu = document.querySelector(".mobile-menu");
  }

  bindEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener("click", () => {
        this.triggerClickHandler();
      });
    });

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.hide());
    }
  }

  triggerClickHandler() {
    this.toggle();
  }

  toggle() {
    this.isHidden() ? this.show() : this.hide();
  }

  hide() {
    this.menu.setAttribute("aria-hidden", "true");
    this.container.setAttribute("data-offcanvas-hidden", "true");
    this.overlay.setAttribute("data-offcanvas-hidden", "true");
    this.searchButton.setAttribute("data-offcanvas-hidden", "true");
    this.loginButton.setAttribute("data-offcanvas-hidden", "true");
    this.triggers.forEach(trigger => {
      trigger.setAttribute("aria-expanded", "false");
    });
    enableBodyScroll(this.mobileMenu);
    clearAllBodyScrollLocks();
  }

  show() {
    disableBodyScroll(this.mobileMenu);
    this.menu?.setAttribute("aria-hidden", "false");
    this.container?.setAttribute("data-offcanvas-hidden", "false");
    this.overlay?.setAttribute("data-offcanvas-hidden", "false");
    this.searchButton?.setAttribute("data-offcanvas-hidden", "false");
    this.loginButton?.setAttribute("data-offcanvas-hidden", "false");
    this.triggers?.forEach(trigger => {
      trigger.setAttribute("aria-expanded", "true");
    });
  }

  isHidden() {
    return this.menu.getAttribute("aria-hidden") === "true";
  }

  setA11yAttributes() {
    const id = generateId();

    this.container.setAttribute("data-offcanvas-hidden", "true");

    if (this.menu) {
      attrs(this.menu, {
        tabindex: "-1",
        "aria-hidden": "true",
        id
      });
    }

    if (this.triggers && this.triggers.length > 0) {
      Array.prototype.forEach.call(this.triggers, trigger => {
        attrs(trigger, {
          role: "button",
          "aria-pressed": "false",
          "aria-expanded": "false"
        });
      });
    }
  }
}

export default init(Offcanvas, "offcanvas");
